<template>
  <div>
    <div class="courcetitle"
         ref="pride_tab_fixed">
      <div class="classtitle">
        <!-- <router-link tag="i"
                     :to="{ name: 'MyCourse'}"
                     class="fa-zhixin fa-mail-reply back-mine-icon"></router-link> -->
                     <i class="fa-zhixin fa-mail-reply back-mine-icon" @click="back"></i>
        {{title}}
      </div>
    </div>
    <div id="mycourceinfo">
      <!-- 左边列表 -->
      <div class="mycource_list"
           ref="class_qqinfo">
        <div class="mycource_list_nav"
             v-if="classType === 'live'&&qqprice&&qqcode">
          <div class="class_code">
            <img :src="qqprice"
                 alt="">
          </div>
          <div class="class_info">
            <div>
              <div class="qqun"
                   v-if="service_type==1">专属 QQ 群：<span>{{qqcode}}</span></div>
              <div class="qqun"
                   v-if="service_type==2">专属班主任：<span>{{qqcode}}</span></div>
              <div class="qwarn"
                   v-if="service_type==1">扫码或搜索群号加入，加群时请<span>备注官网注册手机号</span></div>
              <div class="qwarn"
                   v-if="service_type==2">微信扫码或搜索，添加班主任时请<span>备注官网注册手机号</span></div>
              <div class="content_list">
                <div class="content_info">
                  <div class="qqcontent">学习资料 <span>独家内部资料下载</span></div>
                  <div class="qqcontent">老师互动 <span>疑问随时得到解答</span></div>
                </div>
                <div class="content_info">
                  <div class="qqcontent">同学交流 <span>相互辅导相互监督</span></div>
                  <div class="qqcontent">监督刷题 <span>共同刷题分享收获</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="classinfo_list"
             ref="selected_bar_title">
          <div :class="selectedBarTitleFixed == true ? 'selectedBarTitleFixed' :''"
               ref="classTip"
               :style="selectedBarTitleFixed == true ? 'width:'+tipWidth+'px' :''">
            <div class="classinfo_nav"
                 v-if="yesClass.length!==0&&noClass.length!==0">
              <div class="classstate "
                   @click="changeClassState('no')"
                   :class="classState === 'no'?'check-classstate':''">待上的课</div>
              <div class="classstate "
                   @click="changeClassState('yes')"
                   :class="classState === 'yes'?'check-classstate':''">已上的课</div>
            </div>
            <div class="classinfo_nav"
                 v-if="yesClass.length===0||noClass.length===0">
              <div class="classstate ">全部课程</div>
            </div>
          </div>
          <div class="classinfo_listall"
               v-if="classType === 'live'">
            <div class="box"
                 v-for="(item, index) in controlClass"
                 :key="index">
              <div class="classinfo_listall_top">
                <div style="display:flex;align-items: center;font-size: 14px;height: 19px;">
                  <div>{{item.data}}</div>
                  <div style="margin-left: 20px;">{{item.teachers}}</div>
                </div>
                <div v-if="item.usedata&&item.btnText!=='立即报名'">观看有效期至{{item.usedata}}</div>
              </div>
              <div class="classinfo_listall_down">
                <div style="display: flex;justify-content: space-between;width:100%">
                  <div style="display:flex;max-width:80%;align-items: center;">
                    <h4 class="class_subject">{{item.subject}}</h4>
                    <p class="class_desp">{{item.desp}}</p>
                  </div>
                  <div>
                    <el-button type="primary"
                               class="class-facestate"
                               :disabled="item.btnState === 1"
                               @click="golive(item.href,item.belong,item.btnText)">{{item.btnText}}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="classinfo_listall"
               v-if="classType === 'offline'">
            <div class="box"
                 v-for="(item, index) in controlClass"
                 :key="index">
              <div class="classinfo_listall_top"
                   style="flex-direction: row;justify-content: normal;height: 19px;align-items: center;">
                <div style="margin-right:12px">{{item.data}}</div>
                <div>{{item.teacher_name}}</div>
              </div>
              <div class="classinfo_listall_down"
                   style="justify-content: space-between;">
                <div class="offline-subtitle" style="font-weight:600;font-size:16px;">{{item.subject ? item.subject : `第${index+1}节小课`}}</div>
                <el-button type="primary"
                           class="class-facestate"
                           :disabled="item.disable"
                           @click="gooffline(item)">{{item.text}}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右边日历 -->
      <div class="mycource_calendar">
        <Calender :calenderSend="calenderlist"
                  v-if="calenderlist"
                  @fresh="getMyAllCourse"></Calender>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import $ from 'jquery'
// import moment from 'moment'
import fliter from '@/utils/filters'
import Calender from '@/components/Calendar'
import router from '@/router'

export default {
  data () {
    return {
      cource: [{ name: '直播课' }, { name: '面授课' }, { name: '讲座' }],
      classState: 'no',
      classType: '',
      noClass: [],
      yesClass: [],
      title: '',
      controlClass: [],
      qqcode: 0,
      qqprice: '',
      calenderlist: [],
      btnText: '',
      classtype: '',
      disabled: false,
      titleFixed: false,
      selectedBarTitleFixed: false,
      service_type: 0,
      subClassList: [], // 取日历的数据比较退款的小课
      tipWidth: 0,
      buyOfflineSubclass: []
    }
  },
  components: {
    Calender
  },
  methods: {
    back () {
      if (this.$route.params.vipCardId) {
        router.push({ name: 'VipCard', params: { vipCardId: this.$route.params.vipCardId } })
      } else {
        router.push({ name: 'MyCourse' })
      }
    },
    toinfo (e) {
      this.$router.push({
        name: 'MyCourseInfo',
        params: { classId: e }
      })
    },
    changeClassState (e) {
      window.scroll(0, 0)
      this.classState = e
      if (e === 'yes') {
        this.controlClass = this.yesClass
        // this.btnText = '看回放'
      } else if (e === 'no') {
        this.controlClass = this.noClass
        // this.btnText = '进入直播'
      }
    },
    // 获取课程信息直播课和讲座
    getClassInfo (data) {
      const params = {
        class_id: data
      }
      api.getMyCourseLiveInfo(params)
        .then(r => {
          if (r.data.code === 1) {
            const item = r.data.data.class_info
            this.title = r.data.data.class_info.subject
            this.qqcode = r.data.data.class_info.qq_group_num
            this.qqprice = r.data.data.class_info.qr_code
            this.service_type = r.data.data.class_info.service_type
            const isFreeCourses = Number(item.price) === 0

            const nowTime = parseInt(new Date().getTime() / 1000)
            for (let i = 0; i < item.subclass.length; i++) {
              const refund = this.subClassList.some(sub => {
                return item.subclass[i].subclass_id === sub.subclass_id
              })
              item.subclass[i].data = fliter.formatYMDHM(item.subclass[i].begin_at) + '-' + (fliter.formatYMDHM(item.subclass[i].end_at)).slice(11)
              // item.subclass[i].data = moment.unix(item.subclass[i].begin_at).format('YYYY.MM.DD') + '-' + moment.unix(item.subclass[i].end_at).format('YYYY.MM.DD')
              if ((item.subclass[i].deadline_at) !== null) {
                item.subclass[i].usedata = fliter.formatYMDHMS(item.subclass[i].deadline_at)
                if (nowTime > (item.subclass[i].deadline_at)) {
                  item.subclass[i].btnState = 1
                } else if ((nowTime < (item.subclass[i].deadline_at)) && nowTime + 1800 < item.subclass[i].begin_at) {
                  item.subclass[i].btnState = 1
                } else if ((nowTime < (item.subclass[i].deadline_at)) && nowTime + 1800 > item.subclass[i].begin_at) {
                  item.subclass[i].btnState = 0
                }
              } else {
                if (nowTime + 1800 < item.subclass[i].begin_at) {
                  item.subclass[i].btnState = 1
                } else if (nowTime + 1800 > item.subclass[i].begin_at) {
                  item.subclass[i].btnState = 0
                }
              }
              if ((item.subclass[i].deadline_at) !== null) {
                if (item.subclass[i].end_at < nowTime && nowTime < item.subclass[i].deadline_at) {
                  if (!item.price) {
                    item.subclass[i].btnText = '看回放'
                  } else {
                    item.subclass[i].btnText = refund ? '看回放' : '进入直播'
                  }
                  this.yesClass.push(item.subclass[i])
                } else if (item.subclass[i].end_at > nowTime && nowTime < item.subclass[i].deadline_at) {
                  item.subclass[i].btnText = '进入直播'
                  this.noClass.push(item.subclass[i])
                } else if (this.subClassList.length === 0) {
                  item.subclass[i].btnText = '进入直播'
                  this.noClass.push(item.subclass[i])
                } else if (item.subclass[i].end_at < nowTime && nowTime > item.subclass[i].deadline_at) {
                  item.subclass[i].btnText = '已过期'
                  this.yesClass.push(item.subclass[i])
                }
              } else {
                if (item.subclass[i].end_at < nowTime) {
                  item.subclass[i].btnText = '看回放'
                  this.yesClass.push(item.subclass[i])
                } else if (item.subclass[i].end_at > nowTime) {
                  item.subclass[i].btnText = '进入直播'
                  this.noClass.push(item.subclass[i])
                }
              }

              if (item.subclass[i].btnText === '看回放') {
                item.subclass[i].belong = item.course_belong
                item.subclass[i].href = '/live/' + item.class_id + '/' + item.subclass[i].subclass_id + '/' + 'replay'
              } else if (item.subclass[i].btnText === '进入直播') {
                item.subclass[i].belong = item.course_belong
                item.subclass[i].href = '/live/' + item.class_id + '/' + item.subclass[i].subclass_id + '/' + 'live'
              }
              // 1001: "系统课",
              // 1002: "专题课",
              // 1003: "免费课",
              // 1004: "自选课",
              if (item.subclass[i].btnText === '进入直播' && !isFreeCourses) {
                if (refund === true) {
                  item.subclass[i].btnText = '进入直播'
                } else {
                  item.subclass[i].btnText = '立即报名'
                  item.subclass[i].btnState = 0
                  item.subclass[i].belong = item.course_belong
                }
              }
            }
            this.yesClass = this.yesClass.reverse()
            if (this.yesClass.length === 0 && this.noClass.length !== 0) {
              this.controlClass = this.noClass
            } else if (this.noClass.length === 0 && this.yesClass.length !== 0) {
              this.controlClass = this.yesClass
            } else if (this.noClass.length !== 0 && this.yesClass.length !== 0) {
              this.controlClass = this.noClass
            }
          } else {
            this.$msgDialog('没有此课程', () => {
              this.$router.push({ path: '/' })
            })
          }
        })
        .catch(e => {
          console.log('e: ', e)
        })
    },
    // 获取课程信息面授
    getClassOfflineInfo (data) {
      const params = {
        class_id: data
      }
      api.getMyCourseOfflineInfo(params)
        .then(r => {
          if (r.data.code === 1) {
            const item = r.data.data
            this.title = r.data.data.title
            // this.qqcode = r.data.data.qq_group_num
            // this.qqprice = r.data.data.qr_code
            const nowTime = parseInt(new Date().getTime() / 1000)
            for (let i = 0; i < item.subs_info.length; i++) {
              item.subs_info[i].data = fliter.formatYMDHM(item.subs_info[i].begin_at) + '-' + (fliter.formatYMDHM(item.subs_info[i].end_at)).slice(11)
              // item.subs_info[i].data = moment.unix(item.subs_info[i].begin_at).format('YYYY.MM.DD') + '-' + moment.unix(item.subs_info[i].end_at).format('YYYY.MM.DD')
              // item.subs_info[i].usedata = fliter.formatYMDHMS(item.subcsubs_infolass[i].deadline_at)
              // if (nowTime > fliter.formatYMDHMS(item.subs_info[i].deadline_at)) {
              //   item.subs_info[i].btnState = 0
              // } else {
              //    item.subs_info[i].btnState = 1
              // }
              if (item.subs_info[i].end_at < nowTime) {
                // item.subs_info[i].success = 1
                this.yesClass.push(item.subs_info[i])
              } else {
                this.noClass.push(item.subs_info[i])
              }
              if (this.buyOfflineSubclass.indexOf(Number(item.subs_info[i].subclass_id)) === -1) {
                item.subs_info[i].text = '去报名'
                item.subs_info[i].disable = false
              } else if (this.buyOfflineSubclass.indexOf(Number(item.subs_info[i].subclass_id)) > -1 && item.subs_info[i].end_at < nowTime) {
                item.subs_info[i].text = '看回放'
                item.subs_info[i].disable = false
              } else {
                item.subs_info[i].text = '线下面授'
                item.subs_info[i].disable = true
              }
            }
            this.yesClass = this.yesClass.reverse()
            if (this.yesClass.length === 0 && this.noClass.length !== 0) {
              this.controlClass = this.noClass
            } else if (this.noClass.length === 0 && this.yesClass.length !== 0) {
              this.controlClass = this.yesClass
            } else if (this.noClass.length !== 0 && this.yesClass.length !== 0) {
              this.controlClass = this.noClass
            }
            // })
          } else {
          }
        })
        .catch(e => {
          console.log('e: ', e)
        })
    },
    gooffline (obj) {
      if (obj.text === '去报名') {
        this.$router.push({ name: 'ClassDetail', params: { classId: this.$route.params.classId, classType: 'offline' } })
      } else {
        this.$router.push({
          name: 'offline-live',
          params: { classId: this.$route.params.classId, subId: obj.subclass_id }
        })
      }
    },
    golive (e, g, f) {
      if (f === '立即报名') {
        const arr = e.split('/')
        if (g === '质心灵动量') {
          this.$router.push({
            name: 'ClassDetail',
            params: { classId: arr[2], classType: 'live' }
          })
        } else if (g === '质心官网' || g === '') {
          window.open(process.env.VUE_APP_ZHIXIN_URL + '/#livereg/' + arr[2], '_blank')
        }
      } else {
        if (g === '质心灵动量') {
          const arr = e.split('/')
          this.$router.push({
            name: 'live',
            params: { classId: arr[2], subId: arr[3], action: arr[4] }
          })
        } else if (g === '质心官网' || g === '') {
          const arr = e.replace('/', '#')
          window.open(process.env.VUE_APP_ZHIXIN_URL + arr, '_blank')
        }
      }
    },
    getMyAllCourse () {
      api
        .getMyAllCourse()
        .then(r => {
          if (r.data.code === 1) {
            const item = r.data.items
            // if (this.$route.params.classType === 'offline') {
            //   for (let i = 0; i < item.length; i++) {
            //     this.buyOfflineSubclass[i] = item[i].subclass_id
            //   }
            //   // this.getClassOfflineInfo(this.$route.params.classId)
            // }
            // this.subClassList = item
            this.calenderlist = item.map(item => {
              const nowTime = parseInt(new Date().getTime() / 1000)
              const date = fliter.formatDate(item.begin_at).replace(/\./g, '/')
              const belong = item.course_belong
              const subinfo = item.subject || `第${item.sub_index}节小课`
              const classSubject = item.class_subject
              const className = 'mark1'
              const time = fliter.formatTimestamp(item.begin_at).slice(11, 16) + '-' + fliter.formatTimestamp(item.end_at).slice(11, 16)
              const subClass = item.sub_index + '/' + item.subclass_count
              const classType = item.goods_type
              let btnState = 1
              let btnText = '' // eslint-disable-line no-unused-vars
              let href = ''
              // 按钮点击状态
              if ((item.deadline_at) !== null) {
                if (nowTime > (item.deadline_at)) {
                  btnState = 1
                } else if ((nowTime < (item.deadline_at)) && nowTime < item.begin_at) {
                  btnState = 1
                } else if ((nowTime < (item.deadline_at)) && nowTime > item.begin_at) {
                  btnState = 0
                }
              } else {
                if (classType === 2) {
                  if (nowTime < item.begin_at) {
                    btnState = 1
                  } else if (nowTime > item.begin_at) {
                    btnState = 0
                  }
                } else if (classType === 5) {
                  if (this.buyOfflineSubclass.indexOf(Number(item.subclass_id)) > -1 && nowTime > item.end_at) {
                    btnState = 0
                  } else {
                    btnState = 1
                  }
                }
              }
              // 按钮文字
              if ((item.deadline_at) !== null) {
                if (item.end_at < nowTime && nowTime < item.deadline_at) {
                  btnText = '看回放'
                } else if (item.end_at > nowTime && nowTime < item.deadline_at) {
                  btnText = '进入直播'
                } else if (item.end_at < nowTime && nowTime > item.deadline_at) {
                  btnText = '已过期'
                }
              } else {
                if (classType === 2) {
                  if (item.end_at < nowTime) {
                    btnText = '看回放'
                  } else if (item.end_at > nowTime) {
                    btnText = '进入直播'
                  }
                } else if (classType === 5) {
                  if (this.buyOfflineSubclass.indexOf(Number(item.subclass_id)) > -1 && nowTime > item.end_at) {
                    btnText = '看回放'
                  } else {
                    btnText = '线下面授'
                  }
                }
              }
              if (btnText === '看回放' && classType === 2) {
                href = '/live/' + item.class_id + '/' + item.subclass_id + '/' + 'replay'
              } else if (btnText === '进入直播') {
                href = '/live/' + item.class_id + '/' + item.subclass_id + '/' + 'live'
              } else if (btnText === '看回放' && classType === 5) {
                href = '/offline-live/' + item.class_id + '/' + item.subclass_id
              } else if (btnText === '线下面授') {
                href = 'javascript:void(0)'
              }
              return {
                classType,
                subinfo,
                className,
                classSubject,
                date,
                time,
                btnState,
                btnText,
                subClass,
                href,
                belong
              }
            })
          } else {
          }
        })
        .catch(e => {
          console.log('e: ', e)
        })
    },
    // 获取当前课程的小课状态
    getCurrentSubclass () {
      const type = this.$route.params.classType === 'offline' ? 5 : 2
      api
        .getMyAllCourseNew({ class_id: this.$route.params.classId, goods_type: type })
        .then(r => {
          if (r.data.code === 1) {
            const item = r.data.data || []
            if (this.$route.params.classType === 'offline') {
              for (let i = 0; i < item.length; i++) {
                this.buyOfflineSubclass[i] = item[i].subclass_id
              }
              this.getClassOfflineInfo(this.$route.params.classId)
            }
            this.subClassList = item
          }
        }).catch(e => {
          console.log('e: ', e)
        })
    },
    handleScroll () {
      if (this.$route.name === 'MyCourseInfo') {
        $(window).on('scroll', () => {
          // const offsetTop =
          //   this.$refs.pride_tab_fixed &&
          //   this.$refs.pride_tab_fixed.getBoundingClientRect().top
          // const qqinfoTop =
          //   this.$refs.class_qqinfo &&
          //   this.$refs.class_qqinfo.getBoundingClientRect().top
          const selectedBarTitleFixedtop =
            this.$refs.selected_bar_title &&
            this.$refs.selected_bar_title.getBoundingClientRect().top
          // this.titleFixed = offsetTop < 0
          // this.selectedBarTitleFixed = selectedBarTitleFixedtop < 0
          //
          // const scrollTop =
          //   window.pageYOffset ||
          //   document.documentElement.scrollTop ||
          //   document.body.scrollTop
          if (selectedBarTitleFixedtop <= 50) {
            this.selectedBarTitleFixed = true
          } else {
            this.selectedBarTitleFixed = false
          }
          // this.i = scrollTop
          // const height = 50
          // if (this.$refs.pride_tab_fixed.getBoundingClientRect().top === 100) {
          //   selectedBarTitleFixedtop += 50
          //   console.log('e')
          // }

          // $('.selectedBarTitleFixed').css({ top: -selectedBarTitleFixedtop })
        })
      }
    }
  },
  mounted () {
    this.classType = this.$route.params.classType
    this.getCurrentSubclass()
    if (this.$route.params.classType === 'live') {
      this.getMyAllCourse()
      this.getClassInfo(this.$route.params.classId)
    } else if (this.$route.params.classType === 'offline') {
      this.getMyAllCourse()
    }
    const reftipContainer = this.$refs.classTip
    // this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, true) // 监听（绑定）滚轮滚动事件
    this.$nextTick(() => {
      this.tipWidth = reftipContainer.clientWidth
    })
  },
  created () {

  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll, true)
  }
}
</script>
<style lang="scss">
.courcetitle {
  background: white;
  .classtitle {
    width: 1140px;
    height: 50px;
    line-height: 50px;
    margin: auto;
    font-size: 16px;
    i {
      margin-right: 16px;
      color: rgba(0, 199, 191, 1);
    }
  }
}
#mycourceinfo {
  width: 1140px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  margin-top: 16px;
  .mark1:after {
    position: absolute;
    bottom: 0;
    height: 5px;
    width: 5px;
    content: "";
    background: white;
    border-radius: 50%;
  }
  .mycource_list {
    width: 796px;
    .classinfo_list {
      background: white;
      // margin-top: 10px;
      .selectedBarTitleFixed {
        position: fixed;
        top: 49px;
        z-index: 99;
      }
      .classinfo_nav {
        display: flex;
        height: 40px;
        background: rgba(248, 249, 249, 1);
        .classstate {
          line-height: 40px;
          font-size: 14px;
          color: rgba(44, 45, 46, 1);
          width: 152px;
          text-align: center;
          cursor: pointer;
          border-top: 2px solid rgba(3, 199, 191, 0);
        }
        .check-classstate {
          background: white;
          border-top: 2px solid rgba(3, 199, 191);
        }
      }
    }
    .classinfo_listall {
      background: white;
      .box {
        box-sizing: border-box;
        padding: 24px 24px 8px 24px;
      }
      .classinfo_listall_top {
        display: flex;
        justify-content: space-between;
      }
      .classinfo_listall_down {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        .offline-subtitle{
          word-break: break-all;
        }
        .class_subject {
          margin-right: 20px;
          font-size: 16px;
          height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 303px;
        }
        .class_desp {
          color: rgba(44, 45, 46, 0.4);
          height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 283px;
        }
        .class-facestate {
          // width: 74px;
          height: 30px;
          // background: rgba(222,222,222,1);
          border-radius: 4px;
          text-align: center;
          // line-height: 30px;
          // color: white;
        }
      }
    }
    .mycource_list_nav {
      display: flex;
      background: white;
      height: 156px;
      align-items: center;
      box-sizing: border-box;
      padding-left: 24px;
      .class_code {
        width: 124px;
        height: 124px;
        margin-right: 16px;
        background: grey;
        img {
          width: 124px;
          height: 124px;
        }
      }
      .class_info {
        width: 373px;
        .qqun {
          font-size: 14px;
          color: rgba(51, 51, 51, 0.8);
          span {
            font-size: 22px;
          }
        }
        .content_list {
          display: flex;
          justify-content: space-between;
          margin-top: 23px;
          .qqcontent {
            margin-top: 4px;
            span {
              color: rgba(51, 51, 51, 0.5);
            }
          }
        }
        .qwarn {
          margin-top: 13px;
          font-size: 14px;
          span {
            font-size: 14px;
            font-weight: 600;
          }
        }
      }
    }
    .mycource_list_card {
      margin-top: 24px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .cardlist {
        width: 386px;
        height: 249px;
        // background: skyblue;
      }
    }
  }
  .mycource_calendar {
    width: 323px;
  }
}
@media (max-width: 375px) and (min-width: 320px) {
  #mycourceinfo {
    .mycource_list {
      .classinfo_list {
        width: 375px;
      }
      .mycource_list_nav {
        padding-left: 0px;
        width: 375px;
        height: 189px;
      }
      .classinfo_listall {
        .classinfo_listall_top {
          flex-direction: column;
        }
        .classinfo_listall_down {
          .class_subject {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 101px;
          }
          .class_desp {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 101px;
          }
        }
      }
    }
  }
}
@media (max-width: 375px) and (min-width: 320px) {
  #mycourceinfo {
    width: 100%;
    .mycource_list {
      width: 100%;
      .classinfo_list {
        width: 100%;
        .selectedBarTitleFixed {
          width: 100%;
        }
        .classinfo_nav .classstate {
          width: 50%;
        }
        .classinfo_listall {
          .box {
            .classinfo_listall_down {
              display: flex;
              justify-content: flex-end;
              margin-top: 6px;
            }
          }
        }
      }
    }
    .mycource_calendar {
      display: none;
    }
  }
}
@media (max-width: 768px) and (min-width: 376px) {
  .courcetitle .classtitle {
    width: 755px;
  }
  #mycourceinfo {
    width: 755px;
    .mycource_list {
      width: 413px;
      .classinfo_listall {
        .classinfo_listall_top {
          flex-direction: column;
        }
        .classinfo_listall_down {
          // margin-top: -25px;
          margin-top: 0px;
        }
      }
      .mycource_list_nav {
        height: 193px;
        .mycource_list_navleft div {
          height: 28px;
          border-bottom: 2px solid #00c7bf;
          margin-right: 13px;
        }
      }
      .mycource_list_card {
        justify-content: center;
      }
      .classinfo_list .classinfo_nav .classstate {
        width: 50%;
      }
      .classinfo_list {
        .selectedBarTitleFixed {
          width: 413px;
        }
      }
    }
  }
}
@media (max-width: 1023px) and (min-width: 769px) {
  .courcetitle .classtitle {
    width: 755px;
  }
  #mycourceinfo {
    width: 755px;
    .mycource_list {
      width: 431px;
      .mycource_list_nav {
        height: 207px;
      }
      .mycource_list_nav .mycource_list_navleft div {
        height: 28px;
        border-bottom: 2px solid #00c7bf;
        margin-right: 20px;
      }
      .classinfo_list {
        margin-top: 0px;
      }
    }
  }
}
@media (max-width: 1372px) and (min-width: 1024px) {
  #mycourceinfo {
    width: 999px;
    .mycource_list {
      width: 657px;
      .classinfo_list {
        margin-top: 0px;
      }
    }
  }
  .courcetitle .classtitle {
    padding-left: 17px;
  }
}
</style>
